<template>
  <div class="home wrapper">
    <div class="content">
      <Header></Header>
      <Breadcrumb
        :breadcrumbs="breadcrumbs"
      ></Breadcrumb>
      <Title :title="'Transparência'"></Title>
      <Items></Items>
    </div>
    <!-- /.content -->

    <Footer></Footer>
  </div>
  <!-- /.home wrapper -->
</template>

<script>
  import Header from '../components/Header.vue';
  import Footer from '../components/Footer.vue';
  import Breadcrumb from '../components/Breadcrumb.vue';
  import Items from '../components/Items.vue';
  import Title from '../components/generic/Title.vue';

  export default {
    name: 'home',
    components: {
      Header,
      Footer,
      Breadcrumb,
      Items,
      Title,
    },
    data () {
      return {
        breadcrumbs: [
          {
            name: 'Início',
          }
        ]
      }
    }
  };
</script>
